'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _isNan = require('babel-runtime/core-js/number/is-nan');

var _isNan2 = _interopRequireDefault(_isNan);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _cameras = require('redux/modules/cameras');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _kunaUtils = require('../../utils/kunaUtils');

var _ioBeamUtils = require('../../utils/ioBeamUtils');

var _tempCamerasOnPIR = require('../../utils/tempCamerasOnPIR');

var _tempCamerasOnPIR2 = _interopRequireDefault(_tempCamerasOnPIR);

var _components = require('../../components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CameraWrapper = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    firmware: state.firmware,
    cameras: state.cameras,
    loadedCustomers: state.customers
  };
}, { loadCamera: _cameras.loadIfNeeded }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CameraWrapper, _Component);

  function CameraWrapper(props) {
    (0, _classCallCheck3.default)(this, CameraWrapper);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CameraWrapper.__proto__ || (0, _getPrototypeOf2.default)(CameraWrapper)).call(this, props));

    _this.state = {
      // scriptLoading: true,
      // addedContactEmail: false,
      // client: null,
      // customerName: null,
      handledDynamoDB: false,
      handledIOBeam: false,
      dbResult: undefined
    };
    _this.componentDidMount = _this.componentDidMount.bind(_this);
    _this.client = null;
    return _this;
  }

  (0, _createClass3.default)(CameraWrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // console.log('Serial Number: ' + this.props.sn);
      if (!this.props.email && this.props.sn) {
        this.props.loadCamera(this.props.sn);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _props = this.props,
          sn = _props.sn,
          cameras = _props.cameras;
      var _state = this.state,
          handledDynamoDB = _state.handledDynamoDB,
          handledIOBeam = _state.handledIOBeam;

      var rootCamera = cameras[sn];

      if (!this.props.email && this.props.sn) {
        this.props.loadCamera(this.props.sn);
      }

      // This code below updates the shared DB only when necessary

      // Only call zipper merge when both are loaded
      var performZipperMerge = function performZipperMerge() {
        // DynamoDB is in Seconds, so convert to ms
        var dynamoDBMilliSecs = (0, _ioBeamUtils.modifyResultTimeToMillisecs)(rootCamera.dynamoDB.result);
        // Merge the results of IOBeam and DynamoDB in the
        // case we're sourcing from both
        var dbResult = (0, _ioBeamUtils.zipUpResults)(rootCamera.ioBeam.result, dynamoDBMilliSecs);

        return dbResult;
      };

      if (handledDynamoDB !== rootCamera.dynamoDB.loaded || handledIOBeam !== rootCamera.ioBeam.loaded) {
        var dbResult = performZipperMerge();

        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          dbResult: dbResult,
          handledIOBeam: rootCamera.ioBeam.loaded,
          handledDynamoDB: rootCamera.dynamoDB.loaded
        });
      }

      // console.log('Serial Number: ' + this.props.sn);
      // Make the loadCamera cached so calling it constantly has no perf impact
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          sn = _props2.sn,
          cameras = _props2.cameras,
          email = _props2.email,
          customerName = _props2.customerName,
          zdTicketId = _props2.zdTicketId,
          firmware = _props2.firmware,
          loadedCustomers = _props2.loadedCustomers;
      var _props3 = this.props,
          children = _props3.children,
          rest = (0, _objectWithoutProperties3.default)(_props3, ['children']);
      var dbResult = this.state.dbResult;

      var camera = cameras[sn] ? cameras[sn].root.result : null;
      var rootCamera = cameras[sn];

      if (!camera) {
        return null;
      }

      // onPlan, timezone,
      var shared = camera.owner.email.toLowerCase() !== email;
      var slackDeleteURI = 'slack://channel?team=T03NPMBJG&id=C1W8D9VJA';

      var _getAllUserForms = (0, _kunaUtils.getAllUserForms)(customerName, email, [sn], zdTicketId),
          RMAUrl = _getAllUserForms.RMAUrl,
          returnUrl = _getAllUserForms.returnUrl;

      var djangoUrl = 'https://master.kunasystems.com/kunakuna-admin/camera/camera/' + camera.id + '/';
      var logglyBaseUrl = 'https://kuna.loggly.com/search#terms=';
      var logglyUrl = logglyBaseUrl + 'tag%3A%22' + camera.serial_number + '%22';
      var logglyEndUrl = '&from=-3d&until=now';
      var deleteUrl = djangoUrl + 'delete/';
      var deleteText = 'Can someone please delete ' + camera.serial_number + ' from user ' + this.props.email + ' ' + (shared ? 'with *owner ' + camera.owner.email + '* ' : '') + '\n' + deleteUrl + '\nReason: <Insert>';

      // How far back in time to go looking for normally short term searches
      // When the camera is offline we want to look back further so that we have more context
      var timeframe = camera.status !== 1 && (0, _moment2.default)().subtract(20, 'h').isAfter(camera.down_at) ? 7 : 1;
      var timeframeText = timeframe === 1 ? '24 hrs' : '7 days';

      // Logging for new firmwares adds `json.` in front of certain strings
      var newLogglyFormat = camera.build >= 30040053;
      var severity = newLogglyFormat ? 'json.severity' : 'severity';
      var appName = newLogglyFormat ? 'json.appName' : 'appName';

      var logglyUrls = [{ name: 'Wifi', url: logglyUrl + '%20"wifi"' + logglyEndUrl }, {
        name: 'Error count',
        url: logglyUrl + '%20' + severity + ':"error"' + logglyEndUrl
      }, {
        name: 'S3 upload speed',
        url: logglyUrl + '%20' + appName + ':"kunaimage"%20"s3_video"' + logglyEndUrl
      }, {
        name: 'Recording Started',
        url: logglyUrl + '%20' + appName + ':"kunaimage"%20"action"%20"start"' + logglyEndUrl
      }, {
        name: 'Recording Stopped',
        url: logglyUrl + '%20' + appName + ':"kunaimage"%20"action"%20"stop"' + logglyEndUrl
      }, {
        name: 'Push Notifications (account wide)',
        url: logglyBaseUrl + 'push.send_bulk_push_message%20"' + email + '"' + logglyEndUrl
      }];

      var fullWifiDbmData = (0, _ioBeamUtils.getFieldData)(dbResult, 'wifi.dbm.mean', function (val) {
        return val !== null ? Math.round(val * 100) / 100 : null;
      });
      var timezoneOffset = camera.timezone_offset;

      var wifiChart = _react2.default.createElement(_components.CameraChart, {
        data: fullWifiDbmData,
        label: 'WiFi dBm',
        timezoneOffset: timezoneOffset
      });
      var wifiDbmValue = (0, _ioBeamUtils.getFieldAggregate)(dbResult, 'wifi.dbm.mean', timeframe);
      var wifiDbm = {
        cutoffs: {
          good: function good(val) {
            return val > -55;
          },
          warning: function warning(val) {
            return val > -70;
          }
        },
        rawValue: wifiDbmValue,
        value: Math.round(wifiDbmValue),
        formatting: function formatting(value) {
          return value + ' dbm';
        },
        fieldName: 'WiFi mean (' + timeframeText + ')',
        hoverText: 'The WiFi signal strength, the smaller the number - the stronger the signal',
        extendedInfo: wifiChart,
        alwaysShow: true
      };

      var wifiBitrateValue = (0, _ioBeamUtils.getFieldAggregate)(dbResult, 'wifi.bitrate.mean', timeframe);
      var wifiBitrate = {
        cutoffs: {
          good: function good(val) {
            return val > 80;
          },
          warning: function warning(val) {
            return val > 60;
          }
        },
        rawValue: wifiBitrateValue,
        value: Math.round(wifiBitrateValue / 720000),
        formatting: function formatting(value) {
          return value + '%';
        },
        fieldName: 'WiFi bitrate (' + timeframeText + ')',
        hoverText: Math.round(wifiBitrateValue / 1000000) + ' megabits per second'
      };

      var videoUploadSpeedValue = (0, _ioBeamUtils.getFieldAggregate)(dbResult, 'curl.s3_video.upload_avg_speed.mean', 7);
      var videoUploadSpeedLastDay = (0, _ioBeamUtils.getFieldAggregate)(dbResult, 'curl.s3_video.upload_avg_speed.mean', 1);
      var videoUploadSpeed = {
        cutoffs: {
          good: function good(val) {
            return val > 100;
          },
          warning: function warning(val) {
            return val > 90;
          }
        },
        rawValue: videoUploadSpeedValue,
        value: Math.round(videoUploadSpeedValue / 1000),
        formatting: function formatting(value) {
          return (value > 100 ? 100 : value) + '%';
        },
        fieldName: 'Record upload speed (7 days)',
        hoverText: 'Recording upload speed ' + Math.round(videoUploadSpeedValue / 1000) + ' kB/s to Amazon S3 over the last 7 days (' + Math.round(videoUploadSpeedLastDay / 1000) + ' over last 24 hrs)'
      };

      var drasticActionValue = (0, _ioBeamUtils.getFieldAggregate)(dbResult, 'heartbeat.drastic_action.sum', 7, 'sum');
      var drasticAction = {
        cutoffs: {
          good: function good(val) {
            return val < 5;
          },
          warning: function warning(val) {
            return val < 10;
          }
        },
        rawValue: drasticActionValue,
        value: Math.round(drasticActionValue),
        formatting: function formatting(value) {
          return value + ' times';
        },
        fieldName: 'WiFi drastic actions (7 days)',
        hoverText: 'Number of times the camera has been internally         "rebooted" the wifi in order to attempt to connect to the internet'
      };

      var fullRecordData = (0, _ioBeamUtils.getFieldData)(dbResult, 'record.start.sum', function (val) {
        return val !== null ? Math.round(val * 100) / 100 : NaN;
      });
      var fullSightImagesUploadedData = (0, _ioBeamUtils.getFieldData)(dbResult, 'sight.images_uploaded.sum', function (val) {
        return val !== null ? val : NaN;
      });
      var recordingsGeneratedValue = (0, _ioBeamUtils.getFieldAggregate)(dbResult, 'record.start.sum', 7, 'sum');
      var recordingsGeneratedLastDay = (0, _ioBeamUtils.getFieldAggregate)(dbResult, 'record.start.sum', 1, 'sum');
      var sightImageUploadLastDay = (0, _ioBeamUtils.getFieldAggregate)(dbResult, 'sight.images_uploaded.sum', 1, 'sum');
      var recordChart = _react2.default.createElement(_components.CameraChart, {
        hideLines: true,
        bigPoints: true,
        data: fullRecordData,
        label: 'Recordings Count',
        data2: fullSightImagesUploadedData,
        label2: 'Sight images uploaded',
        timezoneOffset: timezoneOffset
      });
      var recordingsGenerated = {
        normalFormatting: true,
        rawValue: recordingsGeneratedValue,
        value: recordingsGeneratedValue,
        formatting: function formatting(value) {
          return '' + value;
        },
        fieldName: 'Recordings (7 days)',
        extendedInfo: recordChart,
        hoverText: 'Number of recordings and Kuna AI images generated. Number                   of recordings generated in last 24 hours:                  ' + recordingsGeneratedLastDay + ' Number of Kuna AI images                   uploaded in the last 24 hours: ' + sightImageUploadLastDay
      };

      var recordingsBitrateValue = (0, _ioBeamUtils.getFieldAggregate)(dbResult, 'record.bitrate.mean', 7);
      var recordingsBitrate = {
        cutoffs: {
          good: function good(val) {
            return val > 90;
          },
          warning: function warning(val) {
            return val > 50;
          }
        },
        rawValue: videoUploadSpeedValue,
        value: Math.round(recordingsBitrateValue / 15000),
        formatting: function formatting(value) {
          return (value > 100 ? 100 : value) + '%';
        },
        fieldName: 'Recording Bitrate (7 days)',
        hoverText: 'Recording bitrate - aka the quality of the recording ' + Math.round(recordingsBitrateValue / 10000) / 200 + ' Mb/s (at 15fps)'
      };

      var pirEventsValue = (0, _ioBeamUtils.getFieldAggregate)(dbResult, 'pir.event.sum', 7, 'sum');
      var fullPIRData = (0, _ioBeamUtils.getFieldData)(dbResult, 'pir.event.sum', function (val) {
        return val !== null ? Math.round(val * 100) / 100 : NaN;
      });
      var pirChart = _react2.default.createElement(_components.CameraChart, {
        hideLines: true,
        bigPoints: true,
        data: fullPIRData,
        label: 'PIR Count',
        timezoneOffset: timezoneOffset
      });
      var pirEvents = {
        cutoffs: {
          good: function good(val) {
            return val > 30 && val < 500000;
          },
          warning: function warning(val) {
            return val > 10 && val < 100000;
          }
        },
        rawValue: pirEventsValue,
        value: pirEventsValue,
        formatting: function formatting(value) {
          return '' + value;
        },
        fieldName: 'PIR events (7 days)',
        extendedInfo: pirChart,
        hoverText: 'The number of PIR events that have occured. This is                   inherently tied to the sensitivity. If this number is too                   low it means the PIR could be underactive, if too                   high - overactive'
      };

      var iErrorsValue = (0, _ioBeamUtils.getFieldAggregate)(dbResult, 'network.wlan0.ierrors.sum', 7, 'sum');
      var iErrors = {
        cutoffs: {
          good: function good(val) {
            return val === 0;
          },
          warning: function warning(val) {
            return val < 10;
          }
        },
        rawValue: iErrorsValue,
        value: iErrorsValue,
        formatting: function formatting(value) {
          return '' + value;
        },
        fieldName: 'WiFi packet errors (7 days)',
        hoverText: 'How many times communication between device and router had                   really bad failure. These show up when there are channel                   issues or really noisy WiFi environments'
      };

      var rebootsValue = (0, _ioBeamUtils.getFieldAggregate)(dbResult, 'reboots.sum', 7, 'sum');
      var rebootsValueLastDay = (0, _ioBeamUtils.getFieldAggregate)(dbResult, 'reboots.sum', 1, 'sum');
      var reboots = {
        cutoffs: {
          good: function good(val) {
            return val < 2;
          },
          warning: function warning(val) {
            return val < 5;
          }
        },
        rawValue: rebootsValue,
        value: rebootsValue,
        formatting: function formatting(value) {
          return '' + value;
        },
        fieldName: 'Reboots (7 days)',
        hoverText: 'Number of times camera has rebooted, it has rebooted                   ' + rebootsValueLastDay + ' times in the last 24 hours'
      };

      // Find uptime using the new schema and the old schema at the same time
      // New one records in seconds, old records in heartbeats
      // When a new camera is upgraded we want the value for uptime to still
      // be accurate over the given time range
      var uptimeValueNew = (0, _ioBeamUtils.getFieldAggregate)(dbResult, 'heartbeat.online_seconds.sum', 7, 'sum') / (3600 * 24 * 7);
      var uptimeDataNew = (0, _ioBeamUtils.getFieldData)(dbResult, 'heartbeat.online_seconds.sum', function (val) {
        return val !== null ? Math.round(val * 10000 / 3600) / 100 : null;
      });
      var uptimeValueOld = (0, _ioBeamUtils.getFieldAggregate)(dbResult, 'heartbeat.success.sum', 7, 'sum') / (60 * 24 * 7);
      var uptimeDataOld = (0, _ioBeamUtils.getFieldData)(dbResult, 'heartbeat.success.sum', function (val) {
        return val !== null ? Math.round(val * 10000 / 60) / 100 : null;
      });

      // Default to Uptime New, then if needed downgrade to Uptime Old
      var uptimeData = uptimeDataNew;
      var uptimeValue = uptimeValueNew;
      if (Array.isArray(uptimeDataNew) && Array.isArray(uptimeDataOld)) {
        // Find all old uptime data that doesn't overlap with new data.
        var filteredData = uptimeDataOld.filter(function (val) {
          return !uptimeDataNew.find(function (newVal) {
            return newVal.x === val.x;
          });
        });

        if (filteredData.length > 0) {
          // This is not a perfect calculation of uptimeValue as
          // uptimeValueOld will have >=10% of whatever uptimeValueNew is even
          // during the time period uptimeValueOld is active
          // This only impacts the overall summary during the period where
          // both the new and old firmware logs are in the logs
          uptimeValue = uptimeValueNew + uptimeValueOld;
          uptimeData = uptimeDataNew.concat(filteredData);
        }
      } else if (Array.isArray(uptimeDataOld)) {
        uptimeData = uptimeDataOld;
        uptimeValue = uptimeValueOld;
      }
      // const uptimeData = uptimeDataNew.concat(uptimeDataOld);
      var uptimeDataCleaned = (0, _ioBeamUtils.onePointPerHour)(uptimeData);
      var uptimeChart = _react2.default.createElement(_components.CameraChart, {
        data: uptimeDataCleaned,
        label: 'Uptime',
        timezoneOffset: timezoneOffset
      });
      var uptime = {
        cutoffs: {
          good: function good(val) {
            return val > 90;
          },
          warning: function warning(val) {
            return val > 40;
          }
        },
        rawValue: uptimeValue,
        value: Math.round(uptimeValue * 10000) / 100,
        formatting: function formatting(value) {
          return value + '%';
        },
        fieldName: 'Uptime (7 days)',
        extendedInfo: uptimeChart,
        hoverText: 'The percentage of time this device has been online over the                   last 7 days, see graph for detail (specifically able to                   connect both IOBeam and Kuna servers, possible that IOBeam                   service or Kuna service is down)'
      };

      var updatedFailedValue = (0, _ioBeamUtils.getFieldAggregate)(dbResult, 'update.failed.sum', 7, 'sum');
      var updatedFailed = {
        cutoffs: {
          good: function good(val) {
            return val < 1;
          },
          warning: function warning(val) {
            return val < 4;
          }
        },
        rawValue: updatedFailedValue,
        value: updatedFailedValue,
        formatting: function formatting(value) {
          return '' + value;
        },
        fieldName: 'Update Failed (7 days)',
        hoverText: 'The number of times fw update has failed in the last 7 days'
      };

      var wifiChannels = void 0;
      var wifiSSID = void 0;
      var uniqueChannels = void 0;
      var allSSIDs = void 0;
      var wifiBSSID = void 0;
      try {
        if (rootCamera.wifiData.result) {
          var wifiData = rootCamera.wifiData.result;
          // Fix formatting for new camera wifi data reporting scheme
          // IMPORTANT: can NOT switch based off of SN, otherwise
          //            during the switch reporting will fail until all
          //            old loggly logs have been removed.
          wifiData = wifiData.map(function (msg) {
            if (msg.event.json.j) {
              // eslint-disable-next-line no-param-reassign
              msg.event.json = msg.event.json.j.j.w;
            }
            return msg;
          });
          wifiChannels = wifiData.map(function (msg) {
            return msg.event.json.wifi.channel;
          });
          var allSSIDLists = wifiData.filter(function (msg) {
            return msg.event.json.scanlist;
          });
          wifiSSID = wifiData[0].event.json.wifi.ssid;
          uniqueChannels = wifiChannels && wifiChannels.filter(function (val, idx, arr) {
            return arr.indexOf(val) === idx;
          });
          wifiBSSID = allSSIDLists && allSSIDLists[0].event.json.wifi.mac;
          wifiBSSID = wifiBSSID && wifiBSSID.split(':').map(function (val) {
            return val.length === 1 ? '0' + val : val;
          }).join(':');
          allSSIDs = allSSIDLists && allSSIDLists[0].event.json.scanlist;
        }
      } catch (err) {
        console.info(err);
      }

      var extendedWifiData = void 0;
      var extendedInfo = null;
      if (allSSIDs) {
        allSSIDs = allSSIDs.sort(function (net1, net2) {
          return net2.strength - net1.strength;
        });
        extendedWifiData = {};

        var isSameAccessPoint = function isSameAccessPoint(network) {
          return network.bssid.toUpperCase() === wifiBSSID.toUpperCase();
        };
        extendedWifiData.thisNetwork = allSSIDs.filter(isSameAccessPoint);

        // const isCloseChannel = network => Math.abs(network.channel - extendedWifiData.thisNetwork[0].channel) < 4;

        var allOtherNetworks = allSSIDs.filter(function (net) {
          return !isSameAccessPoint(net);
        });
        // const isStrong = network => Math.abs(network.channel - uniqueChannels[0]) < 10;
        extendedWifiData.sameNetworkSSID = allOtherNetworks.filter(function (network) {
          return network.ssid === wifiSSID;
        });
        extendedWifiData.otherNetworks = allOtherNetworks.filter(function (network) {
          return network.ssid !== wifiSSID;
        });
        var networkSpan = function networkSpan(network) {
          return _react2.default.createElement(
            'span',
            null,
            network.strength,
            '% (',
            network.channel,
            ')'
          );
        };
        extendedInfo = _react2.default.createElement(
          'div',
          null,
          extendedWifiData.thisNetwork.map(function (network) {
            return _react2.default.createElement(
              'div',
              { key: network.ssid },
              _react2.default.createElement(
                'strong',
                { className: 'text-success' },
                networkSpan(network)
              ),
              ' : ' + network.ssid
            );
          }),
          extendedWifiData.sameNetworkSSID.map(function (network) {
            return _react2.default.createElement(
              'div',
              { key: network.ssid },
              _react2.default.createElement(
                'strong',
                null,
                networkSpan(network)
              ),
              ' : ' + network.ssid
            );
          }),
          extendedWifiData.otherNetworks.map(function (network) {
            return _react2.default.createElement(
              'div',
              { key: network.ssid },
              networkSpan(network),
              ' : ' + network.ssid
            );
          })
        );
      }

      var wifiChannel = {
        cutoffs: {
          good: function good(val) {
            return val.includes(1) || val.includes(6) || val.includes(11);
          },
          warning: function warning() {
            return false;
          }
        },
        rawValue: uniqueChannels,
        value: uniqueChannels,
        formatting: function formatting(value) {
          return '' + value.join(', ');
        },
        fieldName: 'Wifi Channel',
        extendedInfo: extendedInfo,
        hoverText: 'Wifi Channels should always be on standard channels (1,6,11)                   to avoid interference from the standard channels. SSID: "' + wifiSSID + '"'
      };

      var logglyErrorCount = rootCamera.errorData.result;
      var errorCount = {
        cutoffs: {
          good: function good(val) {
            return val < 1000;
          },
          warning: function warning(val) {
            return val < 20000;
          }
        },
        rawValue: logglyErrorCount,
        value: logglyErrorCount,
        formatting: function formatting(value) {
          return '' + value;
        },
        fieldName: 'Number of errors (7 days)',
        hoverText: 'Number of errors seen via Loggly - click Loggly to see more                   errors, this only has the count'
      };

      var badFlashErrorCount = rootCamera.badFlash.result;
      var badFlashCount = {
        cutoffs: {
          good: function good(val) {
            return val < 1;
          },
          warning: function warning(val) {
            return val < 3;
          }
        },
        rawValue: badFlashErrorCount,
        value: badFlashErrorCount,
        formatting: function formatting(value) {
          return '' + value;
        },
        fieldName: 'Number bad flash errors (7 days)',
        hoverText: 'Number of "bad flash errors" - this indicates that the firmware can\'t update itself'
      };

      /*
      const wifiScanList = {
        cutoffs: {
          good: () => true,
          warning: () => false,
        },
        rawValue: uniqueChannels,
        value: '',
        formatting: value => `${value.join(', ')}`,
        fieldName: 'Wifi Scan',
        hoverText: `Your entire wifi network scan. First Green bolded element is \
                    current network. Other bolded fields are same SSID (same network name) fields.`,
      }; */

      var firmwareModel = (0, _kunaUtils.getModelFromSN)(camera.serial_number);

      var stats = [uptime, recordingsGenerated, pirEvents, recordingsBitrate, reboots, wifiDbm, wifiBitrate, wifiChannel, videoUploadSpeed, drasticAction, iErrors, errorCount, updatedFailed, badFlashCount];

      // Doorbells don't contain some fields, we want to remove them to avoid confusion.
      if (firmwareModel === 'KUNA_V1') {
        // Find index for pirEvents and remove it
        var pirEventsIndex = stats.indexOf(pirEvents);
        stats.splice(pirEventsIndex, 1);
      }

      var upToDateFW = firmware && parseInt(firmware[firmwareModel].version, 10);
      var isFwUpToDate = upToDateFW === camera.build || upToDateFW === undefined || (0, _isNan2.default)(upToDateFW);
      var isBetaFW = upToDateFW < camera.build;

      var _getTrialInfo = (0, _kunaUtils.getTrialInfo)(loadedCustomers, camera.owner.email),
          trial = _getTrialInfo.trial,
          onTrial = _getTrialInfo.onTrial;

      var allSharedUsers = rootCamera.users.result && rootCamera.users.result.results;
      var isNotificationOn = true;
      if (allSharedUsers) {
        var thisUser = allSharedUsers.find(function (user) {
          return user.user.email === email;
        });
        if (thisUser) {
          isNotificationOn = thisUser.notifications_enabled;
        }
      }

      var isPIRSightCamera = _tempCamerasOnPIR2.default.includes(camera.serial_number);

      var isSupportPermissionEnabled = (0, _kunaUtils.isDateInFuture)(camera.support_permission_end);

      var cameraProps = (0, _extends3.default)({}, rest, {
        camera: camera,
        rootCamera: rootCamera,
        stats: stats,
        shared: shared,
        slackDeleteURI: slackDeleteURI,
        RMAUrl: RMAUrl,
        returnUrl: returnUrl,
        djangoUrl: djangoUrl,
        logglyUrl: logglyUrl,
        logglyUrls: logglyUrls,
        deleteUrl: deleteUrl,
        deleteText: deleteText,
        firmwareModel: firmwareModel,
        upToDateFW: upToDateFW,
        isFwUpToDate: isFwUpToDate,
        isBetaFW: isBetaFW,
        trial: trial,
        onTrial: onTrial,
        extendedWifiData: extendedWifiData,
        isNotificationOn: isNotificationOn,
        isPIRSightCamera: isPIRSightCamera,
        isSupportPermissionEnabled: isSupportPermissionEnabled
      });

      return _react2.default.createElement(
        'div',
        null,
        _react.Children.map(children, function (child) {
          return _react2.default.cloneElement(child, cameraProps);
        })
      );
    }
  }]);
  return CameraWrapper;
}(_react.Component), _class2.propTypes = {
  sn: _react.PropTypes.string,
  email: _react.PropTypes.string,
  customerName: _react.PropTypes.string,
  zdTicketId: _react.PropTypes.string,
  onPlan: _react.PropTypes.bool,
  timezone: _react.PropTypes.string,
  firmware: _react.PropTypes.object,
  cameras: _react.PropTypes.object,
  loadedCustomers: _react.PropTypes.object,
  children: _react.PropTypes.object,
  loadCamera: _react.PropTypes.func.isRequired
}, _temp)) || _class);
exports.default = CameraWrapper;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/CameraWrapper/CameraWrapper.js
 ** module id = 1392
 ** module chunks = 0
 **/